<template>
  <!-- ส่วนที่ 1 ข้อมูลเด็กกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกก -->
  <v-card
    max-width="1000"
    class="rounded-b-0 mx-auto"
    :disabled="loading"
    :loading="loading"
  >
    <v-toolbar color="#e81416" id="section-1">
      <v-toolbar-title>
        <h1>{{ $t("info_card.title_page1") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.degree") }}
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page1.level_id_TH,
                en: page1.level_id_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="v-col-12 v-col-sm-6">
          {{
            inlineTranslator({
              th: page1.prefix_name_TH + " :",
              en: page1.prefix_name_EN,
            })
          }}
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page1.faculty_TH,
                en: page1.faculty_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.curriculum") }}
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page1.curriculum_TH,
                en: page1.curriculum_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.name_th") }}
          <span class="pb-1 font-weight-bold">
            {{ page1.name_TH }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.surname_th") }}
          <span class="pb-1 font-weight-bold">{{ page1.surname_TH }}</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.gender") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page1.gender_TH,
                en: page1.gender_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.prename") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page1.prename_TH,
                en: page1.prename_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.name_en_title") }} :
          <span class="pb-1 font-weight-bold">{{ page1.name_EN }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.surname_en_title") }} :
          <span class="pb-1 font-weight-bold">{{ page1.surname_EN }}</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <!-- ส่วนที่ 222222222222222222222222222222222222222222222222222222222222222222222222222222222 -->
    <v-toolbar color="#ffa500" id="section-2">
      <v-toolbar-title>
        <h1>{{ $t("info_card.title_page2") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col class="v-col-12 v-col-sm-12">
          {{ $t("info_card.thai_citizenID") }}
          <span class="pb-1 font-weight-bold">{{ page2.citizen_id }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.thai_citizenID_start_date") }} :
          <span class="pb-1 font-weight-bold">
            <v-icon>mdi-calendar-check</v-icon>{{ d(page2.citizen_start) }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.thai_citizenID_end_date") }} :
          <span class="pb-1 font-weight-bold"><v-icon>mdi-calendar-check</v-icon>{{ d(page2.citizen_end) }}</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.email") }} :
          <span class="pb-1 font-weight-bold">{{ page2.email }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.mobile") }} :
          <span class="pb-1 font-weight-bold">{{ page2.mobile }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.birth_date") }} :
          <span class="pb-1 font-weight-bold">
            <v-icon>mdi-calendar-star</v-icon>
            {{ d(page2.birth_date) }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.nation") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.nation_TH,
                en: page2.nation_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.race") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.race_TH,
                en: page2.race_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.religion") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.religion_TH,
                en: page2.religion_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
      <v-row v-if="page2.nation_id != 'TH'">
        <v-col class="v-col-12 v-col-sm-12">
          {{ $t("info_card.passport_number") }} :
          <span class="pb-1 font-weight-bold">{{ page2.passport_id }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.passport_start_date") }} :
          <span class="pb-1 font-weight-bold">
            <v-icon>mdi-calendar-check</v-icon>{{ d(page2.passport_start) }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.passport_end_date") }} :
          <span class="pb-1 font-weight-bold">
            <v-icon>mdi-calendar-check</v-icon>{{ d(page2.passport_end) }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.talent") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.ability_TH,
                en: page2.ability_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.disability") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.disability_TH,
                en: page2.disability_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
      <v-row v-if="page2.disability_id != '00'">
        <v-divider></v-divider>
        <v-col class="v-col-12 v-col-sm-12">
          {{ $t("info_card.disabilityId") }} :
          <span class="pb-1 font-weight-bold">{{ page2.disability_number }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.disabilityStartDate") }} :
          <span class="pb-1 font-weight-bold">
            <v-icon>mdi-calendar-week</v-icon>
            {{ d(page2.disability_start) }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.disabilityEndDate") }} :
          <span class="pb-1 font-weight-bold">
            <v-icon>mdi-calendar-week</v-icon>
            {{ d(page2.disability_end) }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col class="v-col-12 v-col-sm-12">
          <h3>{{ $t("info_card.address_registration") }}</h3>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          <v-radio-group v-model="page2.ThaiOrForeignCountry" inline disabled>
            <v-radio :label="$t('info_card.in_thai')" value="inThai"> </v-radio>
            <v-radio
              :label="$t('info_card.foreign_country')"
              value="foreignCountry"
            >
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col
          class="v-col-12 v-col-sm-12"
          v-if="page2.ThaiOrForeignCountry === 'foreignCountry'"
        >
          {{ $t("info_card.country") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.home.country_TH,
                en: page2.home.country_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
      <v-row v-if="page2.ThaiOrForeignCountry === 'inThai'">
        <v-col class="v-col-12 v-col-sm-12">
          {{ $t("info_card.house_id") }} :
          <span class="pb-1 font-weight-bold">{{ page2.home.house_id }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.house_number") }} :
          <span class="pb-1 font-weight-bold">{{ page2.home.house_number }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.moo") }} :
          <span class="pb-1 font-weight-bold">{{ page2.home.moo }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.village_name") }} :
          <span class="pb-1 font-weight-bold">{{ page2.home.village_name }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.soi") }} :
          <span class="pb-1 font-weight-bold">{{ page2.home.soi }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.street") }} :
          <span class="pb-1 font-weight-bold">{{ page2.home.street }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.sub_district") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.home.sub_district_TH,
                en: page2.home.sub_district_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.district") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.home.district_TH,
                en: page2.home.district_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.province") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.home.province_TH,
                en: page2.home.province_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col class="v-col-12 v-col-sm-12">
          <h3>{{ $t("info_card.address_contact") }}</h3>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          <v-radio-group v-model="page2.ThaiOrForeignCountry" inline disabled>
            <v-radio :label="$t('info_card.in_thai')" value="inThai"> </v-radio>
            <v-radio
              :label="$t('info_card.foreign_country')"
              value="foreignCountry"
            >
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col
          class="v-col-12 v-col-sm-12"
          v-if="page2.ThaiOrForeignCountry === 'foreignCountry'"
        >
          <span class="pb-1 font-weight-bold">
            {{ $t("info_card.country") }} :
            {{
              inlineTranslator({
                th: page2.contact.country_TH,
                en: page2.contact.country_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
      <v-row v-if="page2.ThaiOrForeignCountry === 'inThai'">
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.house_number") }} :
          <span class="pb-1 font-weight-bold">
            {{ page2.contact.house_number }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.moo") }} :
          <span class="pb-1 font-weight-bold">{{ page2.contact.moo }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.village_name") }} :
          <span class="pb-1 font-weight-bold">
            {{ page2.contact.village_name }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.soi") }} :
          <span class="pb-1 font-weight-bold">{{ page2.contact.soi }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.street") }} :
          <span class="pb-1 font-weight-bold">{{ page2.contact.street }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.sub_district") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.contact.sub_district_TH,
                en: page2.contact.sub_district_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.district") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.contact.district_TH,
                en: page2.contact.district_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.province") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page2.contact.province_TH,
                en: page2.contact.province_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <!-- ส่วนที่ 33333333333333333333333333333333333333333333 กรณีระดับปริญญาตรี -->
    <div v-if="level_id === '1'">
      <v-toolbar color="#faeb36" id="section-3">
        <v-toolbar-title>
          <h1>{{ $t("info_card.title_page3") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-12">
            <h3>{{ $t("info_card.school_location") }}</h3>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.school_type") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page3.school_type_TH,
                  en: page3.school_type_EN,
                })
              }}
            </span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.education_type") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page3.education_type_TH,
                  en: page3.education_type_EN,
                })
              }}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-12">
            <v-radio-group v-model="page3.SchoolThaiOrNot" inline disabled>
              <v-radio :label="$t('info_card.in_thai')" value="itThai">
              </v-radio>
              <v-radio :label="$t('info_card.foreign_country')" value="itNot">
              </v-radio> </v-radio-group></v-col
        ></v-row>
        <div v-if="page3.SchoolThaiOrNot === 'itThai'">
          <v-row>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.province") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page3.province_school_TH,
                    en: page3.province_school_EN,
                  })
                }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.school_name") }} :
              <span class="pb-1 font-weight-bold">
                {{ page3.school_thai }}
              </span>
            </v-col>
          </v-row>
        </div>
        <div v-if="page3.SchoolThaiOrNot === 'itNot'">
          <v-row>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.country") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page3.country_school_TH,
                    en: page3.country_school_EN,
                  })
                }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.school_name") }} :
              <span class="pb-1 font-weight-bold">{{ page3.school_not }}</span>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-12">
            {{ $t("info_card.school_student_id") }} :
            <span class="pb-1 font-weight-bold">{{ page3.school_id }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.school_grad_date") }} :
            <span class="pb-1 font-weight-bold">
              <v-icon>mdi-calendar</v-icon> {{ d(page3.school_end) }}
            </span></v-col
          >
          <v-col class="v-col-12 v-col-sm-12">
            {{ $t("info_card.GPA_hint") }} :
            <span class="pb-1 font-weight-bold">{{ page3.school_gpa }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-12">
            <h3>{{ $t("info_card.first_encounter") }}</h3>
          </v-col>
          <v-col cols="12" sm="12">
            <v-radio-group v-model="page3.FirstOrSecond" inline disabled>
              <v-radio :label="$t('info_card.first_time')" value="firstTime">
              </v-radio>
              <v-radio :label="$t('info_card.second_time')" value="secondTime">
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <div v-if="page3.FirstOrSecond === 'secondTime'">
          <v-row>
            <v-col class="v-col-12 v-col-sm-12">
              {{ $t("info_card.old_studentID") }} :
              <span class="pb-1 font-weight-bold">{{ page3.old_student_id }}</span>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider></v-divider>
    </div>
    <!-- ส่วนที่ 33333333333333333333333333333333333333333333 กรณีระดับบัณฑิตศึกษา -->
    <div v-if="level_id != '1'">
      <v-toolbar color="#faeb36" id="section-3">
        <v-toolbar-title>
          <h1>{{ $t("info_card.title_page3") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-12">
            <h3>{{ $t("info_card.university_location") }}</h3>
          </v-col>
          <v-col cols="12" sm="12">
            <v-radio-group v-model="page3.UniThaiOrNot" inline disabled>
              <v-radio :label="$t('info_card.in_thai')" value="uniThai">
              </v-radio>
              <v-radio :label="$t('info_card.foreign_country')" value="uniNot">
              </v-radio> </v-radio-group></v-col
        ></v-row>
        <div v-if="page3.UniThaiOrNot === 'uniThai'">
          <v-row>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.province") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page3.province_university_TH,
                    en: page3.province_university_EN,
                  })
                }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.university_name") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page3.university_thai_TH,
                    en: page3.university_thai_EN,
                  })
                }}
              </span>
            </v-col>
          </v-row>
        </div>
        <div v-if="page3.UniThaiOrNot === 'uniNot'">
          <v-row>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.country") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page3.country_university_TH,
                    en: page3.country_university_EN,
                  })
                }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.university_name") }} :
              <span class="pb-1 font-weight-bold">
                {{ page3.university_not }}
              </span>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.faculty_college") }} :
            <span class="pb-1 font-weight-bold">{{ page3.faculty }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.curriculum_name") }} :
            <span class="pb-1 font-weight-bold">{{ page3.curriculum }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.graduated_year") }} :
            <span class="pb-1 font-weight-bold">{{ page3.uni_end }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            GPA :
            <span class="pb-1 font-weight-bold">{{ page3.uni_gpa }}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
    <v-divider></v-divider>
    <!-- ส่วนที่ 4 ข้อมูลบิดาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาาา -->
    <v-toolbar color="#79c314" id="section-4">
      <v-toolbar-title>
        <h1>{{ $t("info_card.title_page4") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.prename") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page4.prename_TH,
                en: page4.prename_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("list.name") }} :
          <span class="pb-1 font-weight-bold">{{ page4.father_name }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("list.surname") }} :
          <span class="pb-1 font-weight-bold">{{ page4.father_surname }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.vital_status") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page4.status_TH,
                en: page4.status_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <div v-if="page4.status_TH === 'มีชีวิต'">
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-radio-group v-model="page4.FatherThaiOrNot" inline disabled>
              <v-radio :label="$t('info_card.thai_parent')" value="faThai">
              </v-radio>
              <v-radio :label="$t('info_card.foreigner_parent')" value="faNot">
              </v-radio>
            </v-radio-group>
          </v-col>
          <div v-if="page4.FatherThaiOrNot === 'faThai'">
            <v-col class="v-col-12 v-col-sm-12">
              {{ $t("info_card.fill_thai_citizenID") }} :
              <span class="pb-1 font-weight-bold">
                {{ page4.fa_citizen }}
              </span>
            </v-col>
          </div>
          <div v-if="page4.FatherThaiOrNot === 'faNot'">
            <v-col class="v-col-12 v-col-sm-12">
              {{ $t("info_card.fill_passport_number") }} :
              <span class="pb-1 font-weight-bold">
                {{ page4.fa_passport }}
              </span>
            </v-col>
          </div>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.mobile") }} :
            <span class="pb-1 font-weight-bold">{{ page4.fa_mobile }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.occupation") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page4.fa_occupation_TH,
                  en: page4.fa_occupation_EN,
                })
              }}
            </span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.revenue") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page4.fa_revenue_TH,
                  en: page4.fa_revenue_EN,
                })
              }}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-12">
            <h3>{{ $t("info_card.address_contact") }}</h3>
          </v-col>
          <v-col class="v-col-12 v-col-sm-12">
            <v-radio-group v-model="page4.faAddressThaiOrNot" inline disabled>
              <v-radio :label="$t('info_card.in_thai')" value="faAdThai">
              </v-radio>
              <v-radio :label="$t('info_card.foreign_country')" value="faAdNot">
              </v-radio>
            </v-radio-group>
          </v-col>
          <div v-if="page4.faAddressThaiOrNot === 'faAdNot'">
            <v-col class="v-col-12 v-col-sm-12">
              {{ $t("info_card.country") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page4.fa_contact.country_TH,
                    en: page4.fa_contact.country_EN,
                  })
                }}
              </span>
            </v-col>
          </div>
        </v-row>
        <div v-if="page4.faAddressThaiOrNot === 'faAdThai'">
          <v-row>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.house_number") }} :
              <span class="pb-1 font-weight-bold">
                {{ page4.fa_contact.house_number }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.moo") }} :
              <span class="pb-1 font-weight-bold">{{ page4.fa_contact.moo }}</span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.village_name") }} :
              <span class="pb-1 font-weight-bold">
                {{ page4.fa_contact.village_name }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.soi") }} :
              <span class="pb-1 font-weight-bold">{{ page4.fa_contact.soi }}</span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.street") }} :
              <span class="pb-1 font-weight-bold">{{ page4.fa_contact.street }}</span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.sub_district") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page4.fa_contact.sub_district_TH,
                    en: page4.fa_contact.sub_district_EN,
                  })
                }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.district") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page4.fa_contact.district_TH,
                    en: page4.fa_contact.district_EN,
                  })
                }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.province") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page4.fa_contact.province_TH,
                    en: page4.fa_contact.province_EN,
                  })
                }}
              </span>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </div>
    <v-divider></v-divider>
    <!-- ส่วนที่ 55555555555555555555555555555555555555555555555555555555555555555 มารดาาาาาาาาา -->
    <v-toolbar color="#487de7" id="section-5">
      <v-toolbar-title>
        <h1>{{ $t("info_card.title_page5") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.prename") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page5.prename_TH,
                en: page5.prename_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("list.name") }} :
          <span class="pb-1 font-weight-bold">{{ page5.mother_name }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("list.surname") }} :
          <span class="pb-1 font-weight-bold">{{ page5.mother_surname }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.vital_status") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page5.status_TH,
                en: page5.status_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <div v-if="page5.status_TH === 'มีชีวิต'">
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-radio-group v-model="page5.MotherThaiOrNot" inline disabled>
              <v-radio :label="$t('info_card.thai_parent')" value="moThai">
              </v-radio>
              <v-radio :label="$t('info_card.foreigner_parent')" value="moNot">
              </v-radio>
            </v-radio-group>
          </v-col>
          <div v-if="page5.MotherThaiOrNot === 'moThai'">
            <v-col class="v-col-12 v-col-sm-12">
              {{ $t("info_card.fill_thai_citizenID") }} :
              <span class="pb-1 font-weight-bold">
                {{ page5.mo_citizen }}
              </span>
            </v-col>
          </div>
          <div v-if="page5.MotherThaiOrNot === 'moNot'">
            <v-col class="v-col-12 v-col-sm-12">
              {{ $t("info_card.fill_passport_number") }} :
              <span class="pb-1 font-weight-bold">
                {{ page5.mo_passport }}
              </span>
            </v-col>
          </div>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.mobile") }} :
            <span class="pb-1 font-weight-bold">{{ page5.mo_mobile }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.occupation") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page5.mo_occupation_TH,
                  en: page5.mo_occupation_EN,
                })
              }}
            </span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.revenue") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page5.mo_revenue_TH,
                  en: page5.mo_revenue_EN,
                })
              }}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-12">
            <h3>{{ $t("info_card.address_contact") }}</h3>
          </v-col>
          <v-col class="v-col-12 v-col-sm-12">
            <v-radio-group v-model="page5.moAddressThaiOrNot" inline disabled>
              <v-radio :label="$t('info_card.in_thai')" value="moAdThai">
              </v-radio>
              <v-radio :label="$t('info_card.foreign_country')" value="moAdNot">
              </v-radio>
            </v-radio-group>
          </v-col>
          <div v-if="page5.moAddressThaiOrNot === 'moAdNot'">
            <v-col class="v-col-12 v-col-sm-12">
              {{ $t("info_card.country") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page5.mo_contact.country_TH,
                    en: page5.mo_contact.country_EN,
                  })
                }}
              </span>
            </v-col>
          </div>
        </v-row>
        <div v-if="page5.moAddressThaiOrNot === 'moAdThai'">
          <v-row>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.house_number") }} :
              <span class="pb-1 font-weight-bold">
                {{ page5.mo_contact.house_number }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.moo") }} :
              <span class="pb-1 font-weight-bold">{{ page5.mo_contact.moo }}</span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.village_name") }} :
              <span class="pb-1 font-weight-bold">
                {{ page5.mo_contact.village_name }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.soi") }} :
              <span class="pb-1 font-weight-bold">{{ page5.mo_contact.soi }}</span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.street") }} :
              <span class="pb-1 font-weight-bold">{{ page5.mo_contact.street }}</span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.sub_district") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page5.mo_contact.sub_district_TH,
                    en: page5.mo_contact.sub_district_EN,
                  })
                }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.district") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page5.mo_contact.district_TH,
                    en: page5.mo_contact.district_EN,
                  })
                }}
              </span>
            </v-col>
            <v-col class="v-col-12 v-col-sm-6">
              {{ $t("info_card.province") }} :
              <span class="pb-1 font-weight-bold">
                {{
                  inlineTranslator({
                    th: page5.mo_contact.province_TH,
                    en: page5.mo_contact.province_EN,
                  })
                }}
              </span>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </div>
    <v-divider></v-divider>
    <!-- ข้อมูลส่วนที่ 6 ข้อมูลผู้ปกครองงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงงง -->
    <v-toolbar color="#191970" id="section-6">
      <v-toolbar-title>
        <h1>{{ $t("info_card.title_page6") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="12">
          <v-radio-group v-model="page6.ChooseYourParent" row disabled>
            <v-row>
              <v-col cols="12" sm="2">
                <v-radio :label="$t('info_card.father')" value="father">
                </v-radio>
              </v-col>
              <v-col cols="12" sm="2">
                <v-radio :label="$t('info_card.mother')" value="mother">
                </v-radio>
              </v-col>
              <v-col cols="12" sm="3">
                <v-radio :label="$t('info_card.new_parent')" value="other">
                </v-radio>
              </v-col>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row v-if="page6.ChooseYourParent === 'other'">
        <v-col class="v-col-12 v-col-sm-12">
          {{ $t("info_card.relative") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page6.relation_TH,
                en: page6.relation_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.prename") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page6.prename_TH,
                en: page6.prename_EN,
              })
            }}
          </span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("list.name") }} :
          <span class="pb-1 font-weight-bold">{{ page6.parent_name }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("list.surname") }} :
          <span class="pb-1 font-weight-bold">{{ page6.parent_surname }}</span>
        </v-col>
        <v-col class="v-col-12 v-col-sm-6">
          {{ $t("info_card.vital_status") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page6.status_TH,
                en: page6.status_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <div
      v-if="page6.ChooseYourParent === 'other' && page6.status_TH === 'มีชีวิต'"
    >
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-radio-group v-model="page6.ParentThaiOrNot" inline disabled>
              <v-radio :label="$t('info_card.thai_parent')" value="paThai">
              </v-radio>
              <v-radio :label="$t('info_card.foreigner_parent')" value="paNot">
              </v-radio>
            </v-radio-group>
          </v-col>
          <div v-if="page6.ParentThaiOrNot === 'paThai'">
            <v-col class="v-col-12 v-col-sm-12">
              {{ $t("info_card.fill_thai_citizenID") }} :
              <span class="pb-1 font-weight-bold">
                {{ page6.parent_citizen }}
              </span>
            </v-col>
          </div>
          <div v-if="page6.ParentThaiOrNot === 'paNot'">
            <v-col class="v-col-12 v-col-sm-12">
              {{ $t("info_card.fill_passport_number") }} :
              <span class="pb-1 font-weight-bold">
                {{ page6.parent_passport }}
              </span>
            </v-col>
          </div>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.mobile") }} :
            <span class="pb-1 font-weight-bold">{{ page6.parent_mobile }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.occupation") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page6.parent_occapation_TH,
                  en: page6.parent_occapation_EN,
                })
              }}
            </span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.revenue") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page6.parent_revenue_TH,
                  en: page6.parent_revenue_EN,
                })
              }}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="v-col-12 v-col-sm-12">
            <h3>{{ $t("info_card.address_contact") }}</h3>
          </v-col>
          <v-col class="v-col-12 v-col-sm-12">
            <v-radio-group v-model="page6.paAddressThaiOrNot" inline disabled>
              <v-radio :label="$t('info_card.in_thai')" value="paAdThai">
              </v-radio>
              <v-radio :label="$t('info_card.foreign_country')" value="paAdNot">
              </v-radio>
            </v-radio-group>
          </v-col>
          <v-col
            class="v-col-12 v-col-sm-12"
            v-if="page6.paAddressThaiOrNot === 'paAdNot'"
          >
            {{ $t("info_card.country") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page6.pa_contact.country_TH,
                  en: page6.pa_contact.country_EN,
                })
              }}
            </span>
          </v-col>
        </v-row>
        <v-row v-if="page6.paAddressThaiOrNot === 'paAdThai'">
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.house_number") }} :
            <span class="pb-1 font-weight-bold">
              {{ page6.pa_contact.house_number }}
            </span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.moo") }} :
            <span class="pb-1 font-weight-bold">{{ page6.pa_contact.moo }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.village_name") }} :
            <span class="pb-1 font-weight-bold">
              {{ page6.pa_contact.village_name }}
            </span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.soi") }} :
            <span class="pb-1 font-weight-bold">{{ page6.pa_contact.soi }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.street") }} :
            <span class="pb-1 font-weight-bold">{{ page6.pa_contact.street }}</span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.sub_district") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page6.pa_contact.sub_district_TH,
                  en: page6.pa_contact.sub_district_EN,
                })
              }}
            </span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.district") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page6.pa_contact.district_TH,
                  en: page6.pa_contact.district_EN,
                })
              }}
            </span>
          </v-col>
          <v-col class="v-col-12 v-col-sm-6">
            {{ $t("info_card.province") }} :
            <span class="pb-1 font-weight-bold">
              {{
                inlineTranslator({
                  th: page6.pa_contact.province_TH,
                  en: page6.pa_contact.province_EN,
                })
              }}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col class="v-col-12 v-col-sm-12">
          {{ $t("info_card.parent_status") }} :
          <span class="pb-1 font-weight-bold">
            {{
              inlineTranslator({
                th: page6.famo_relationship_TH,
                en: page6.famo_relationship_EN,
              })
            }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <!-- ส่วนที่ 7777777777777777777777777777777777777777777777777777777777777 อะไรนะ -->
    <v-toolbar color="#70369d" id="section-7">
      <v-toolbar-title>
        <h1>{{ $t("info_card.title_page7") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <v-checkbox
        v-model="page7.isChecked"
        label="ข้าพเจ้าตกลงยินยอมให้ใช้และเปิดเผยข้อมูลของข้าพเจ้าตามที่ระบุข้างต้น
            (กรณีผู้ยินยอมให้ใช้และเปิดเผยข้อมูลเป็นผู้เยาว์
            ต้องส่งหนังสือให้ความยินยอมจากบิดา มารดา
            หรือผู้ปกครองตามกฎหมาย)"
        disabled
      >
      </v-checkbox>
      วันที่กดยืนยันข้อมูลและยอมรับข้อตกลง :
      <span class="pb-1 font-weight-bold">{{ d(page7.confirm_date) }}</span>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  inlineTranslator,
  objectTranslator,
  dateFromDBTranslatorFull as d,
} from "@/helper/translator";
import PageProvider from "@/services/page.provider";
const pageService = new PageProvider();
export default {
  name: "SectionOne",
  components: {},
  props: {
    modelValue: Object,
  },
  data: () => ({
    loading: false,
    level_id: null,
    page1: {
      level_id_TH: null,
      level_id_EN: null,
      prefix_name_TH: null,
      prefix_name_EN: null,
      faculty_TH: null,
      faculty_EN: null,
      curriculum_TH: null,
      curriculum_EN: null,
      prename_TH: null,
      prename_EN: null,
      name_TH: null,
      surname_TH: null,
      name_EN: null,
      surname_EN: null,
      gender_TH: null,
      gender_EN: null,
    },
    page2: {
      citizen_id: null,
      citizen_start: null,
      citizen_end: null,
      email: null,
      mobile: null,
      birth_date: null,
      nation_id: null,
      nation_TH: null,
      nation_EN: null,
      race_TH: null,
      race_EN: null,
      religion_TH: null,
      religion_EN: null,
      passport_id: null,
      passport_start: null,
      passport_end: null,
      ability_TH: null,
      ability_EN: null,
      disability_id: null,
      disability_TH: null,
      disability_EN: null,
      disability_number: null,
      disability_start: null,
      disability_end: null,
      ThaiOrForeignCountry: null,
      home: {
        house_id: null,
        house_number: null,
        moo: null,
        village_name: null,
        soi: null,
        street: null,
        province_TH: null,
        province_EN: null,
        district_TH: null,
        district_EN: null,
        sub_district_TH: null,
        sub_district_EN: null,
        country_id: null,
        country_TH: null,
        country_EN: null,
      },
      contact: {
        house_number: null,
        moo: null,
        village_name: null,
        soi: null,
        street: null,
        province_TH: null,
        province_EN: null,
        district_TH: null,
        district_EN: null,
        sub_district_TH: null,
        sub_district_EN: null,
        country_id: null,
        country_TH: null,
        country_EN: null,
      },
    },
    page3: {
      school_type_TH: null,
      school_type_EN: null,
      education_type_TH: null,
      education_type_EN: null,
      education_nation: null,
      SchoolThaiOrNot: null,
      province_school_TH: null,
      province_school_EN: null,
      school_thai: null,
      country_school_TH: null,
      country_school_EN: null,
      school_not: null,
      school_id: null,
      school_end: null,
      school_gpa: null,
      FirstOrSecond: null,
      old_student_id: null,
      UniThaiOrNot: null,
      province_university_EN: null,
      province_university_TH: null,
      university_thai_TH: null,
      university_thai_EN: null,
      country_university_TH: null,
      country_university_EN: null,
      university_not: null,
      faculty: null,
      curriculum: null,
      uni_end: null,
      uni_gpa: null,
    },
    page4: {
      prename_TH: null,
      prename_EN: null,
      father_name: null,
      father_surname: null,
      status_TH: null,
      status_EN: null,
      FatherThaiOrNot: null,
      fa_citizen: null,
      fa_passport: null,
      fa_mobile: null,
      fa_occupation_TH: null,
      fa_occupation_EN: null,
      fa_revenue_TH: null,
      fa_revenue_EN: null,
      faAddressThaiOrNot: null,
      fa_contact: {
        house_number: null,
        moo: null,
        village_name: null,
        soi: null,
        street: null,
        province_TH: null,
        province_EN: null,
        district_TH: null,
        district_EN: null,
        sub_district_TH: null,
        sub_district_EN: null,
        country_id: null,
        country_TH: null,
        country_EN: null,
      },
    },
    page5: {
      prename_TH: null,
      prename_EN: null,
      mother_name: null,
      mother_surname: null,
      status_TH: null,
      status_EN: null,
      MotherThaiOrNot: null,
      mo_citizen: null,
      mo_passport: null,
      mo_mobile: null,
      mo_occupation_TH: null,
      mo_occupation_EN: null,
      mo_revenue_TH: null,
      mo_revenue_EN: null,
      moAddressThaiOrNot: null,
      mo_contact: {
        house_number: null,
        moo: null,
        village_name: null,
        soi: null,
        street: null,
        province_TH: null,
        province_EN: null,
        district_TH: null,
        district_EN: null,
        sub_district_TH: null,
        sub_district_EN: null,
        country_id: null,
        country_TH: null,
        country_EN: null,
      },
    },
    page6: {
      ChooseYourParent: null,
      relation_TH: null,
      relation_EN: null,
      prename_TH: null,
      prename_EN: null,
      parent_name: null,
      parent_surname: null,
      status_TH: null,
      status_EN: null,
      ParentThaiOrNot: null,
      parent_citizen: null,
      parent_passport: null,
      parent_mobile: null,
      parent_occapation_TH: null,
      parent_occapation_EN: null,
      parent_revenue_TH: null,
      parent_revenue_EN: null,
      paAddressThaiOrNot: null,
      pa_contact: {
        house_number: null,
        moo: null,
        village_name: null,
        soi: null,
        street: null,
        province_TH: null,
        province_EN: null,
        district_TH: null,
        district_EN: null,
        sub_district_TH: null,
        sub_district_EN: null,
        country_id: null,
        country_TH: null,
        country_EN: null,
      },
      famo_relationship_TH: null,
      famo_relationship_EN: null,
    },
    page7: {
      isChecked: null,
      confirm_date: null,
    },
  }),
  methods: {
    d,
    objectTranslator,
    inlineTranslator,
    async fetch_data() {
      this.loading = true;
      const data = await pageService
        .getPageKMITL1(this.uid, this.student_id)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      if (data) {
        this.level_id = data.PAGE1.LEVEL_ID;
        this.page1.level_id_TH = data.PAGE1.LEVEL_NAME_TH;
        this.page1.level_id_EN = data.PAGE1.LEVEL_NAME_EN;
        this.page1.prefix_name_TH = data.PAGE1.prefix_name_th;
        this.page1.prefix_name_EN = data.PAGE1.prefix_name_en;
        this.page1.faculty_TH = data.PAGE1.faculty_name;
        this.page1.faculty_EN = data.PAGE1.faculty_ename;
        this.page1.curriculum_TH = data.PAGE1.CURRICULUM2_NAME_TH;
        this.page1.curriculum_EN = data.PAGE1.CURRICULUM2_NAME_EN;
        this.page1.prename_TH = data.PAGE1.FULLNAME_TH;
        this.page1.prename_EN = data.PAGE1.FULLNAME_EN;
        this.page1.name_TH = data.PAGE1.STUDENT_FNAME_TH;
        this.page1.surname_TH = data.PAGE1.STUDENT_LNAME_TH;
        this.page1.name_EN = data.PAGE1.STUDENT_FNAME_EN;
        this.page1.surname_EN = data.PAGE1.STUDENT_LNAME_EN;
        this.page1.gender_TH = data.PAGE1.GENDER_NAME_TH;
        this.page1.gender_EN = data.PAGE1.GENDER_NAME_EN;

        this.page2.citizen_id = data.PAGE2.CITIZEN_ID;
        this.page2.citizen_start = data.PAGE2.CITIZEN_ID_CARD_ISSUE_DATE;
        this.page2.citizen_end = data.PAGE2.CITIZEN_ID_CARD_EXPIRY_DATE;
        this.page2.email = data.PAGE2.EMAIL;
        this.page2.mobile = data.PAGE2.MOBILE;
        this.page2.birth_date = data.PAGE2.BIRTHDAY;
        this.page2.nation_id = data.PAGE2.NATION_ID;
        this.page2.nation_TH = data.PAGE2.NATION_NAME_TH;
        this.page2.nation_EN = data.PAGE2.NATION_NAME_EN;
        this.page2.race_TH = data.PAGE2.RACE_NAME_TH;
        this.page2.race_EN = data.PAGE2.RACE_NAME_EN;
        this.page2.religion_TH = data.PAGE2.RELIGION_NAME_TH;
        this.page2.religion_EN = data.PAGE2.RELIGION_NAME_EN;
        this.page2.passport_id = data.PAGE2.PASSPORT_NUMBER;
        this.page2.passport_start = data.PAGE2.PASSPORT_STARTDATE;
        this.page2.passport_end = data.PAGE2.PASSPORT_ENDDATE;
        this.page2.ability_TH = data.PAGE2.TALENT_NAME_TH;
        this.page2.ability_EN = data.PAGE2.TALENT_NAME_EN;
        this.page2.disability_id = data.PAGE2.DISABILITY_ID;
        this.page2.disability_TH = data.PAGE2.DISABILITY_NAME_TH;
        this.page2.disability_EN = data.PAGE2.DISABILITY_NAME_EN;
        this.page2.disability_number = data.PAGE2.DEFORMCARD_ID;
        this.page2.disability_start = data.PAGE2.DEFORMCARD_STARTDATE;
        this.page2.disability_end = data.PAGE2.DEFORMCARD_ENDDATE;
        if (this.page2.nation_id === "TH") {
          this.page2.ThaiOrForeignCountry = "inThai";
        } else {
          this.page2.ThaiOrForeignCountry = "foreignCountry";
        }
        this.page2.home.house_id = data.PAGE2.home.HOUSE_ID;
        this.page2.home.house_number = data.PAGE2.home.HOUSE_NUMBER;
        this.page2.home.moo = data.PAGE2.home.MOO;
        this.page2.home.village_name = data.PAGE2.home.VILLAGE_NAME;
        this.page2.home.soi = data.PAGE2.home.SOI;
        this.page2.home.street = data.PAGE2.home.STREET;
        this.page2.home.province_TH = data.PAGE2.home.PROVINCE_NAME_TH;
        this.page2.home.province_EN = data.PAGE2.home.PROVINCE_NAME_EN;
        this.page2.home.district_TH = data.PAGE2.home.DISTRICT_NAME_TH;
        this.page2.home.district_EN = data.PAGE2.home.DISTRICT_NAME_EN;
        this.page2.home.sub_district_TH = data.PAGE2.home.SUB_DISTRICT_NAME_TH;
        this.page2.home.sub_district_EN = data.PAGE2.home.SUB_DISTRICT_NAME_EN;
        this.page2.home.country_id = data.PAGE2.home.NATION_ID;
        this.page2.home.country_TH = data.PAGE2.NATION_NAME_TH;
        this.page2.home.country_EN = data.PAGE2.NATION_NAME_EN;
        this.page2.contact.house_number = data.PAGE2.contact.HOUSE_NUMBER;
        this.page2.contact.moo = data.PAGE2.contact.MOO;
        this.page2.contact.village_name = data.PAGE2.contact.VILLAGE_NAME;
        this.page2.contact.soi = data.PAGE2.contact.SOI;
        this.page2.contact.street = data.PAGE2.contact.STREET;
        this.page2.contact.province_TH = data.PAGE2.contact.PROVINCE_NAME_TH;
        this.page2.contact.province_EN = data.PAGE2.contact.PROVINCE_NAME_EN;
        this.page2.contact.district_TH = data.PAGE2.contact.DISTRICT_NAME_TH;
        this.page2.contact.district_EN = data.PAGE2.contact.DISTRICT_NAME_EN;
        this.page2.contact.sub_district_TH =
          data.PAGE2.contact.SUB_DISTRICT_NAME_TH;
        this.page2.contact.sub_district_EN =
          data.PAGE2.contact.SUB_DISTRICT_NAME_EN;
        this.page2.contact.country_id = data.PAGE2.contact.NATION_ID;
        this.page2.contact.country_TH = data.PAGE2.NATION_NAME_TH;
        this.page2.contact.country_EN = data.PAGE2.NATION_NAME_EN;

        this.page3.school_type_TH = data.PAGE3.SCHOOL_TYPE_NAME_TH;
        this.page3.school_type_EN = data.PAGE3.SCHOOL_TYPE_NAME_EN;
        this.page3.education_type_TH = data.PAGE3.EDUCATION_TYPE_NAME_TH;
        this.page3.education_type_EN = data.PAGE3.EDUCATION_TYPE_NAME_EN;
        this.page3.education_nation = data.PAGE3.EDUCATION_NATION;
        if (this.page3.education_nation === "TH") {
          this.page3.SchoolThaiOrNot = "itThai";
        } else this.page3.SchoolThaiOrNot = "itNot";
        this.page3.province_school_TH = data.PAGE3.PROVINCE_NAME_TH;
        this.page3.province_school_EN = data.PAGE3.PROVINCE_NAME_EN;
        this.page3.school_thai = data.PAGE3.SCHOOL_NAME;
        this.page3.country_school_TH = data.PAGE3.NATION_NAME_TH;
        this.page3.country_school_EN = data.PAGE3.NATION_NAME_EN;
        this.page3.school_not = data.PAGE3.SCHOOL_NAME;
        this.page3.school_id = data.PAGE3.SCHOOL_STUDENT_ID;
        this.page3.school_end = data.PAGE3.SCHOOL_GRAD_DATE;
        this.page3.school_gpa = data.PAGE3.GPA;
        this.page3.old_student_id = data.PAGE3.OLD_KMITL_STUDENT_ID;
        if (this.page3.old_student_id === "") {
          this.page3.FirstOrSecond = "firstTime";
        } else this.page3.FirstOrSecond = "secondTime";
        if (this.page3.education_nation === "TH") {
          this.page3.UniThaiOrNot = "uniThai";
        } else this.page3.UniThaiOrNot = "uniNot";
        this.page3.province_university_TH = data.PAGE3.PROVINCE_NAME_TH;
        this.page3.province_university_EN = data.PAGE3.PROVINCE_NAME_EN;
        this.page3.university_thai_TH = data.PAGE3.UNIVERSITY_NAME_TH;
        this.page3.university_thai_EN = data.PAGE3.UNIVERSITY_NAME_EN;
        this.page3.country_university_TH = data.PAGE3.NATION_NAME_TH;
        this.page3.country_university_EN = data.PAGE3.NATION_NAME_EN;
        this.page3.university_not = data.PAGE3.UNIVERSITY_NAME;
        this.page3.faculty = data.PAGE3.FACULTY_NAME;
        this.page3.curriculum = data.PAGE3.CURRICULUM_NAME;
        this.page3.uni_end = data.PAGE3.YEAR;
        this.page3.uni_gpa = data.PAGE3.GPA;

        this.page4.prename_TH = data.PAGE4.FULLNAME_TH;
        this.page4.prename_EN = data.PAGE4.FULLNAME_EN;
        this.page4.father_name = data.PAGE4.PARENT_FNAME_TH;
        this.page4.father_surname = data.PAGE4.PARENT_LNAME_TH;
        this.page4.status_TH = data.PAGE4.VITAL_STATUS_NAME_TH;
        this.page4.status_EN = data.PAGE4.VITAL_STATUS_NAME_EN;
        this.page4.fa_citizen = data.PAGE4.CITIZEN_ID;
        this.page4.fa_passport = data.PAGE4.PASSPORT_NUMBER;
        if (
          this.page4.fa_citizen.length == 13 &&
          this.page4.fa_passport === ""
        ) {
          this.page4.FatherThaiOrNot = "faThai";
        } else if (
          this.page4.fa_citizen === "" &&
          this.page4.fa_passport != ""
        ) {
          this.page4.FatherThaiOrNot = "faNot";
        }
        this.page4.fa_mobile = data.PAGE4.MOBILE;
        this.page4.fa_occupation_TH = data.PAGE4.OCCUPATION_NAME_TH;
        this.page4.fa_occupation_EN = data.PAGE4.OCCUPATION_NAME_EN;
        this.page4.fa_revenue_TH = data.PAGE4.REVENUE_NAME_TH;
        this.page4.fa_revenue_EN = data.PAGE4.REVENUE_NAME_EN;
        if (data.PAGE4.home && data.PAGE4.home.HOUSE_NUMBER) {
          this.page4.fa_contact.house_number = data.PAGE4.home.HOUSE_NUMBER;
        } else if (data.PAGE4.contact && data.PAGE4.contact.HOUSE_NUMBER) {
          this.page4.fa_contact.house_number = data.PAGE4.contact.HOUSE_NUMBER;
        } else if (data.PAGE4.other && data.PAGE4.other.HOUSE_NUMBER) {
          this.page4.fa_contact.house_number = data.PAGE4.other.HOUSE_NUMBER;
        }
        if (data.PAGE4.home && data.PAGE4.home.MOO) {
          this.page4.fa_contact.moo = data.PAGE4.home.MOO;
        } else if (data.PAGE4.contact && data.PAGE4.contact.MOO) {
          this.page4.fa_contact.moo = data.PAGE4.contact.MOO;
        } else if (data.PAGE4.other && data.PAGE4.other.MOO) {
          this.page4.fa_contact.moo = data.PAGE4.other.MOO;
        }
        if (data.PAGE4.home && data.PAGE4.home.VILLAGE_NAME) {
          this.page4.fa_contact.village_name = data.PAGE4.home.VILLAGE_NAME;
        } else if (data.PAGE4.contact && data.PAGE4.contact.VILLAGE_NAME) {
          this.page4.fa_contact.village_name = data.PAGE4.contact.VILLAGE_NAME;
        } else if (data.PAGE4.other && data.PAGE4.other.VILLAGE_NAME) {
          this.page4.fa_contact.village_name = data.PAGE4.other.VILLAGE_NAME;
        }
        if (data.PAGE4.home && data.PAGE4.home.SOI) {
          this.page4.fa_contact.soi = data.PAGE4.home.SOI;
        } else if (data.PAGE4.contact && data.PAGE4.contact.SOI) {
          this.page4.fa_contact.soi = data.PAGE4.contact.SOI;
        } else if (data.PAGE4.other && data.PAGE4.other.SOI) {
          this.page4.fa_contact.soi = data.PAGE4.other.SOI;
        }
        if (data.PAGE4.home && data.PAGE4.home.STREET) {
          this.page4.fa_contact.street = data.PAGE4.home.STREET;
        } else if (data.PAGE4.contact && data.PAGE4.contact.STREET) {
          this.page4.fa_contact.street = data.PAGE4.contact.STREET;
        } else if (data.PAGE4.other && data.PAGE4.other.STREET) {
          this.page4.fa_contact.street = data.PAGE4.other.STREET;
        }
        if (data.PAGE4.home && data.PAGE4.home.PROVINCE_NAME_TH) {
          this.page4.fa_contact.province_TH = data.PAGE4.home.PROVINCE_NAME_TH;
        } else if (data.PAGE4.contact && data.PAGE4.contact.PROVINCE_NAME_TH) {
          this.page4.fa_contact.province_TH =
            data.PAGE4.contact.PROVINCE_NAME_TH;
        } else if (data.PAGE4.other && data.PAGE4.other.PROVINCE_NAME_TH) {
          this.page4.fa_contact.province_TH = data.PAGE4.other.PROVINCE_NAME_TH;
        }
        if (data.PAGE4.home && data.PAGE4.home.PROVINCE_NAME_EN) {
          this.page4.fa_contact.province_EN = data.PAGE4.home.PROVINCE_NAME_EN;
        } else if (data.PAGE4.contact && data.PAGE4.contact.PROVINCE_NAME_EN) {
          this.page4.fa_contact.province_EN =
            data.PAGE4.contact.PROVINCE_NAME_EN;
        } else if (data.PAGE4.other && data.PAGE4.other.PROVINCE_NAME_EN) {
          this.page4.fa_contact.province_EN = data.PAGE4.other.PROVINCE_NAME_EN;
        }
        if (data.PAGE4.home && data.PAGE4.home.DISTRICT_NAME_TH) {
          this.page4.fa_contact.district_TH = data.PAGE4.home.DISTRICT_NAME_TH;
        } else if (data.PAGE4.contact && data.PAGE4.contact.DISTRICT_NAME_TH) {
          this.page4.fa_contact.district_TH =
            data.PAGE4.contact.DISTRICT_NAME_TH;
        } else if (data.PAGE4.other && data.PAGE4.other.DISTRICT_NAME_TH) {
          this.page4.fa_contact.district_TH = data.PAGE4.other.DISTRICT_NAME_TH;
        }
        if (data.PAGE4.home && data.PAGE4.home.DISTRICT_NAME_EN) {
          this.page4.fa_contact.district_EN = data.PAGE4.home.DISTRICT_NAME_EN;
        } else if (data.PAGE4.contact && data.PAGE4.contact.DISTRICT_NAME_EN) {
          this.page4.fa_contact.district_EN =
            data.PAGE4.contact.DISTRICT_NAME_EN;
        } else if (data.PAGE4.other && data.PAGE4.other.DISTRICT_NAME_EN) {
          this.page4.fa_contact.district_EN = data.PAGE4.other.DISTRICT_NAME_EN;
        }
        if (data.PAGE4.home && data.PAGE4.home.SUB_DISTRICT_NAME_TH) {
          this.page4.fa_contact.sub_district_TH =
            data.PAGE4.home.SUB_DISTRICT_NAME_TH;
        } else if (
          data.PAGE4.contact &&
          data.PAGE4.contact.SUB_DISTRICT_NAME_TH
        ) {
          this.page4.fa_contact.sub_district_TH =
            data.PAGE4.contact.SUB_DISTRICT_NAME_TH;
        } else if (data.PAGE4.other && data.PAGE4.other.SUB_DISTRICT_NAME_TH) {
          this.page4.fa_contact.sub_district_TH =
            data.PAGE4.other.SUB_DISTRICT_NAME_TH;
        }
        if (data.PAGE4.home && data.PAGE4.home.SUB_DISTRICT_NAME_EN) {
          this.page4.fa_contact.sub_district_EN =
            data.PAGE4.home.SUB_DISTRICT_NAME_EN;
        } else if (
          data.PAGE4.contact &&
          data.PAGE4.contact.SUB_DISTRICT_NAME_EN
        ) {
          this.page4.fa_contact.sub_district_EN =
            data.PAGE4.contact.SUB_DISTRICT_NAME_EN;
        } else if (data.PAGE4.other && data.PAGE4.other.SUB_DISTRICT_NAME_EN) {
          this.page4.fa_contact.sub_district_EN =
            data.PAGE4.other.SUB_DISTRICT_NAME_EN;
        }
        if (data.PAGE4.home && data.PAGE4.home.NATION_ID) {
          this.page4.fa_contact.country_id = data.PAGE4.home.NATION_ID;
        } else if (data.PAGE4.contact && data.PAGE4.contact.NATION_ID) {
          this.page4.fa_contact.country_id = data.PAGE4.contact.NATION_ID;
        } else if (data.PAGE4.other && data.PAGE4.other.NATION_ID) {
          this.page4.fa_contact.country_id = data.PAGE4.other.NATION_ID;
        }
        if (this.page4.fa_contact.country_id === "TH") {
          this.page4.faAddressThaiOrNot = "faAdThai";
        } else this.page4.faAddressThaiOrNot = "faAdNot";
        if (data.PAGE4.home && data.PAGE4.home.NATION_NAME_TH) {
          this.page4.fa_contact.country_TH = data.PAGE4.home.NATION_NAME_TH;
        } else if (data.PAGE4.contact && data.PAGE4.contact.NATION_NAME_TH) {
          this.page4.fa_contact.country_TH = data.PAGE4.contact.NATION_NAME_TH;
        } else if (data.PAGE4.other && data.PAGE4.other.NATION_NAME_TH) {
          this.page4.fa_contact.country_TH = data.PAGE4.other.NATION_NAME_TH;
        }
        if (data.PAGE4.home && data.PAGE4.home.NATION_NAME_EN) {
          this.page4.fa_contact.country_EN = data.PAGE4.home.NATION_NAME_EN;
        } else if (data.PAGE4.contact && data.PAGE4.contact.NATION_NAME_EN) {
          this.page4.fa_contact.country_EN = data.PAGE4.contact.NATION_NAME_EN;
        } else if (data.PAGE4.other && data.PAGE4.other.NATION_NAME_EN) {
          this.page4.fa_contact.country_EN = data.PAGE4.other.NATION_NAME_EN;
        }

        this.page5.prename_TH = data.PAGE5.FULLNAME_TH;
        this.page5.prename_EN = data.PAGE5.FULLNAME_EN;
        this.page5.mother_name = data.PAGE5.PARENT_FNAME_TH;
        this.page5.mother_surname = data.PAGE5.PARENT_LNAME_TH;
        this.page5.status_TH = data.PAGE5.VITAL_STATUS_NAME_TH;
        this.page5.status_EN = data.PAGE5.VITAL_STATUS_NAME_EN;
        this.page5.mo_citizen = data.PAGE5.CITIZEN_ID;
        this.page5.mo_passport = data.PAGE5.PASSPORT_NUMBER;
        if (
          this.page5.mo_citizen.length == 13 &&
          this.page5.mo_passport === ""
        ) {
          this.page5.MotherThaiOrNot = "moThai";
        } else if (
          this.page5.mo_citizen === "" &&
          this.page5.mo_passport != ""
        ) {
          this.page5.MotherThaiOrNot = "moNot";
        }
        this.page5.mo_mobile = data.PAGE5.MOBILE;
        this.page5.mo_occupation_TH = data.PAGE5.OCCUPATION_NAME_TH;
        this.page5.mo_occupation_EN = data.PAGE5.OCCUPATION_NAME_EN;
        this.page5.mo_revenue_TH = data.PAGE5.REVENUE_NAME_TH;
        this.page5.mo_revenue_EN = data.PAGE5.REVENUE_NAME_EN;
        if (data.PAGE5.home) {
          this.page5.mo_contact.house_number = data.PAGE5.home.HOUSE_NUMBER;
          this.page5.mo_contact.moo = data.PAGE5.home.MOO;
          this.page5.mo_contact.village_name = data.PAGE5.home.VILLAGE_NAME;
          this.page5.mo_contact.soi = data.PAGE5.home.SOI;
          this.page5.mo_contact.street = data.PAGE5.home.STREET;
          this.page5.mo_contact.province_TH = data.PAGE5.home.PROVINCE_NAME_TH;
          this.page5.mo_contact.province_EN = data.PAGE5.home.PROVINCE_NAME_EN;
          this.page5.mo_contact.district_TH = data.PAGE5.home.DISTRICT_NAME_TH;
          this.page5.mo_contact.district_EN = data.PAGE5.home.DISTRICT_NAME_EN;
          this.page5.mo_contact.sub_district_TH =
            data.PAGE5.home.SUB_DISTRICT_NAME_TH;
          this.page5.mo_contact.sub_district_EN =
            data.PAGE5.home.SUB_DISTRICT_NAME_EN;
          this.page5.mo_contact.country_id = data.PAGE5.home.NATION_ID;
          this.page5.mo_contact.country_TH = data.PAGE5.home.NATION_NAME_TH;
          this.page5.mo_contact.country_EN = data.PAGE5.home.NATION_NAME_EN;
        } else if (data.PAGE5.contact) {
          this.page5.mo_contact.house_number = data.PAGE5.contact.HOUSE_NUMBER;
          this.page5.mo_contact.moo = data.PAGE5.contact.MOO;
          this.page5.mo_contact.village_name = data.PAGE5.contact.VILLAGE_NAME;
          this.page5.mo_contact.soi = data.PAGE5.contact.SOI;
          this.page5.mo_contact.street = data.PAGE5.contact.STREET;
          this.page5.mo_contact.province_TH =
            data.PAGE5.contact.PROVINCE_NAME_TH;
          this.page5.mo_contact.province_EN =
            data.PAGE5.contact.PROVINCE_NAME_EN;
          this.page5.mo_contact.district_TH =
            data.PAGE5.contact.DISTRICT_NAME_TH;
          this.page5.mo_contact.district_EN =
            data.PAGE5.contact.DISTRICT_NAME_EN;
          this.page5.mo_contact.sub_district_TH =
            data.PAGE5.contact.SUB_DISTRICT_NAME_TH;
          this.page5.mo_contact.sub_district_EN =
            data.PAGE5.contact.SUB_DISTRICT_NAME_EN;
          this.page5.mo_contact.country_id = data.PAGE5.contact.NATION_ID;
          this.page5.mo_contact.country_TH = data.PAGE5.contact.NATION_NAME_TH;
          this.page5.mo_contact.country_EN = data.PAGE5.contact.NATION_NAME_EN;
        } else if (data.PAGE5.other) {
          this.page5.mo_contact.house_number = data.PAGE5.other.HOUSE_NUMBER;
          this.page5.mo_contact.moo = data.PAGE5.other.MOO;
          this.page5.mo_contact.village_name = data.PAGE5.other.VILLAGE_NAME;
          this.page5.mo_contact.soi = data.PAGE5.other.SOI;
          this.page5.mo_contact.street = data.PAGE5.other.STREET;
          this.page5.mo_contact.province_TH = data.PAGE5.other.PROVINCE_NAME_TH;
          this.page5.mo_contact.province_EN = data.PAGE5.other.PROVINCE_NAME_EN;
          this.page5.mo_contact.district_TH = data.PAGE5.other.DISTRICT_NAME_TH;
          this.page5.mo_contact.district_EN = data.PAGE5.other.DISTRICT_NAME_EN;
          this.page5.mo_contact.sub_district_TH =
            data.PAGE5.other.SUB_DISTRICT_NAME_TH;
          this.page5.mo_contact.sub_district_EN =
            data.PAGE5.other.SUB_DISTRICT_NAME_EN;
          this.page5.mo_contact.country_id = data.PAGE5.other.NATION_ID;
          this.page5.mo_contact.country_TH = data.PAGE5.other.NATION_NAME_TH;
          this.page5.mo_contact.country_EN = data.PAGE5.other.NATION_NAME_EN;
        }
        if (this.page5.mo_contact.country_id === "TH") {
          this.page5.moAddressThaiOrNot = "moAdThai";
        } else this.page5.moAddressThaiOrNot = "moAdNot";

        if (data.PAGE6.parent_type) {
          this.page6.ChooseYourParent = data.PAGE6.parent_type;
        } else this.page6.ChooseYourParent = "other";
        this.page6.famo_relationship_TH = data.PAGE6.PAR_STATUS_NAME_TH;
        this.page6.famo_relationship_EN = data.PAGE6.PAR_STATUS_NAME_EN;
        this.page6.relation_TH = data.PAGE6.PAR_RELATIVE_NAME_TH;
        this.page6.relation_EN = data.PAGE6.PAR_RELATIVE_NAME_EN;
        this.page6.prename_TH = data.PAGE6.FULLNAME_TH;
        this.page6.prename_EN = data.PAGE6.FULLNAME_EN;
        this.page6.parent_name = data.PAGE6.PARENT_FNAME_TH;
        this.page6.parent_surname = data.PAGE6.PARENT_LNAME_TH;
        this.page6.status_TH = data.PAGE6.VITAL_STATUS_NAME_TH;
        this.page6.status_EN = data.PAGE6.VITAL_STATUS_NAME_EN;
        this.page6.parent_citizen = data.PAGE6.CITIZEN_ID;
        this.page6.parent_passport = data.PAGE6.PASSPORT_NUMBER;
        if (
          this.page6.parent_citizen != "" &&
          this.page6.parent_passport === ""
        ) {
          this.page6.ParentThaiOrNot = "paThai";
        } else if (
          this.page6.parent_citizen === "" &&
          this.page6.parent_passport != ""
        ) {
          this.page6.ParentThaiOrNot = "paNot";
        }
        this.page6.parent_mobile = data.PAGE6.MOBILE;
        this.page6.parent_occapation_TH = data.PAGE6.OCCUPATION_NAME_TH;
        this.page6.parent_occapation_EN = data.PAGE6.OCCUPATION_NAME_EN;
        this.page6.parent_revenue_TH = data.PAGE6.REVENUE_NAME_TH;
        this.page6.parent_revenue_EN = data.PAGE6.REVENUE_NAME_EN;
        if (data.PAGE6.home) {
          this.page6.pa_contact.house_number = data.PAGE6.home.HOUSE_NUMBER;
          this.page6.pa_contact.moo = data.PAGE6.home.MOO;
          this.page6.pa_contact.village_name = data.PAGE6.home.VILLAGE_NAME;
          this.page6.pa_contact.soi = data.PAGE6.home.SOI;
          this.page6.pa_contact.street = data.PAGE6.home.STREET;
          this.page6.pa_contact.province_TH = data.PAGE6.home.PROVINCE_NAME_TH;
          this.page6.pa_contact.province_EN = data.PAGE6.home.PROVINCE_NAME_EN;
          this.page6.pa_contact.district_TH = data.PAGE6.home.DISTRICT_NAME_TH;
          this.page6.pa_contact.district_EN = data.PAGE6.home.DISTRICT_NAME_EN;
          this.page6.pa_contact.sub_district_TH =
            data.PAGE6.home.SUB_DISTRICT_NAME_TH;
          this.page6.pa_contact.sub_district_EN =
            data.PAGE6.home.SUB_DISTRICT_NAME_EN;
          this.page6.pa_contact.country_id = data.PAGE6.home.NATION_ID;
          this.page6.pa_contact.country_TH = data.PAGE6.home.NATION_NAME_TH;
          this.page6.pa_contact.country_EN = data.PAGE6.home.NATION_NAME_EN;
        } else if (data.PAGE6.contact) {
          this.page6.pa_contact.house_number = data.PAGE6.contact.HOUSE_NUMBER;
          this.page6.pa_contact.moo = data.PAGE6.contact.MOO;
          this.page6.pa_contact.village_name = data.PAGE6.contact.VILLAGE_NAME;
          this.page6.pa_contact.soi = data.PAGE6.contact.SOI;
          this.page6.pa_contact.street = data.PAGE6.contact.STREET;
          this.page6.pa_contact.province_TH =
            data.PAGE6.contact.PROVINCE_NAME_TH;
          this.page6.pa_contact.province_EN =
            data.PAGE6.contact.PROVINCE_NAME_EN;
          this.page6.pa_contact.district_TH =
            data.PAGE6.contact.DISTRICT_NAME_TH;
          this.page6.pa_contact.district_EN =
            data.PAGE6.contact.DISTRICT_NAME_EN;
          this.page6.pa_contact.sub_district_TH =
            data.PAGE6.contact.SUB_DISTRICT_NAME_TH;
          this.page6.pa_contact.sub_district_EN =
            data.PAGE6.contact.SUB_DISTRICT_NAME_EN;
          this.page6.pa_contact.country_id = data.PAGE6.contact.NATION_ID;
          this.page6.pa_contact.country_TH = data.PAGE6.contact.NATION_NAME_TH;
          this.page6.pa_contact.country_EN = data.PAGE6.contact.NATION_NAME_EN;
        } else if (data.PAGE6.other) {
          this.page6.pa_contact.house_number = data.PAGE6.other.HOUSE_NUMBER;
          this.page6.pa_contact.moo = data.PAGE6.other.MOO;
          this.page6.pa_contact.village_name = data.PAGE6.other.VILLAGE_NAME;
          this.page6.pa_contact.soi = data.PAGE6.other.SOI;
          this.page6.pa_contact.street = data.PAGE6.other.STREET;
          this.page6.pa_contact.province_TH = data.PAGE6.other.PROVINCE_NAME_TH;
          this.page6.pa_contact.province_EN = data.PAGE6.other.PROVINCE_NAME_EN;
          this.page6.pa_contact.district_TH = data.PAGE6.other.DISTRICT_NAME_TH;
          this.page6.pa_contact.district_EN = data.PAGE6.other.DISTRICT_NAME_EN;
          this.page6.pa_contact.sub_district_TH =
            data.PAGE6.other.SUB_DISTRICT_NAME_TH;
          this.page6.pa_contact.sub_district_EN =
            data.PAGE6.other.SUB_DISTRICT_NAME_EN;
          this.page6.pa_contact.country_id = data.PAGE6.other.NATION_ID;
          this.page6.pa_contact.country_TH = data.PAGE6.other.NATION_NAME_TH;
          this.page6.pa_contact.country_EN = data.PAGE6.other.NATION_NAME_EN;
        }
        if (this.page6.pa_contact.country_id === "TH") {
          this.page6.paAddressThaiOrNot = "paAdThai";
        } else this.page6.paAddressThaiOrNot = "paAdNot";

        this.page7.confirm_date = data.PAGE7.CONFIRM_DATE;
        if (data.PAGE7.CONFIRM_DATE) {
          this.page7.isChecked = true;
        } else this.page7.isChecked = false;

        this.$emit("update:modelValue", {
          level_id_TH: this.page1.level_id_TH,
          level_id_EN: this.page1.level_id_EN,
          prefix_name_TH: this.page1.prefix_name_TH,
          prefix_name_EN: this.page1.prefix_name_EN,
          faculty_TH: this.page1.faculty_TH,
          faculty_EN: this.page1.faculty_EN,
          curriculum_TH: this.page1.curriculum_TH,
          curriculum_EN: this.page1.curriculum_EN,
        });
      }

      this.loading = false;
    },
  },
  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },
    student_id() {
      return this.$store.state.user.surrogated_student_id;
    },
  },
  created() {
    this.fetch_data();
  },
};
</script>

<style scoped>
.v-theme--KMITLTheme {
  --v-disabled-opacity: 1;
}

span {
  font-size: 16px !important;
}
</style>
